<div class="cellWrapper" [ngClass]="cellWrapperClass()">
    @if (shouldDisplayPill()) {
        @if (isMultiPillDisplay()) {
            @for (value of valuesArray(); track value; let last = $last) {
                <span class="coloredPillWrapper" [ngClass]="multiPillsDisplayMapping()[value | lowercase]" [class.pill-margin]="!last">
                    {{ value | translate }}
                </span>
            }
        } @else {
            @if (hasTooltip()) {
                <span
                    class="coloredPillWrapper hasTooltip"
                    [ngClass]="pillType()"
                    appTooltip
                    [component]="tooltipComponent()"
                    [componentData]="tooltipData()"
                    [position]="tooltipPosition()"
                    [trigger]="tooltipTrigger()"
                >
                    {{ displayValue() | translate }}
                </span>
            } @else {
                <span class="coloredPillWrapper" [ngClass]="pillType()">
                    {{ displayValue() | translate }}
                </span>
            }
        }
    }
</div>
